import { render, staticRenderFns } from "./banners-create.vue?vue&type=template&id=5e39f336&"
import script from "./banners-create.vue?vue&type=script&lang=js&"
export * from "./banners-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports